<!--
 * @Author: DYM
 * @Date: 2020-03-16 14:36:50
 * @LastEditors: DQL
 * @LastEditTime: 2023-04-27 15:16:54
 * @Description: 用户管理（单身份）
 -->
<template>
  <el-row
    v-loading="loading"
    type="flex"
    class="l-page l-page--nav"
  >
    <!-- 左侧导航模块 Start -->
    <el-col
      class="l-page__aside"
      :xl="5"
      :lg="6"
      :md="8"
      :span="10"
    >
      <div
        class="l-page--inner l-page--aside"
      >
        <!-- 左侧头部 Start -->
        <div
          class="l-page__header"
        >
          <!-- 左侧标题 -->
          <h2
            class="c-page__header-title"
          >
            组织树
          </h2>
        </div>
        <!-- 左侧头部 End -->

        <!-- 左侧导航主内容 Start -->
        <div
          class="l-page__body"
        >
          <hm-page-card
            class="c-card--aside"
          >
            <!-- 树导航 Start -->
            <div
              class="c-asideTree"
            >
              <div
                class="c-asideTree__body"
              >
                <!-- tree的ref的命名根据业务名称修改 -->
                <el-tree
                  class="o-tree-overflow--unset"
                  :load="loadDeptTree"
                  :props="defaultProps"
                  highlight-current
                  :expand-on-click-node="false"
                  lazy
                  @node-click="handleNodeClick"
                />
              </div>
            </div>
            <!-- 树导航 End -->
          </hm-page-card>
        </div>
      </div>
    </el-col>
    <!-- 左侧导航模块 End -->

    <!-- 右侧主面板模块 Start -->
    <!-- 右侧用户信息 -->
    <el-col
      class="l-page__panel"
      :xl="19"
      :lg="18"
      :md="16"
      :span="14"
    >
      <!-- 右侧内容：查询类布局 Start -->
      <div
        class="l-page--inner l-page--search"
      >
        <!-- 页面头部 Start -->
        <div
          class="l-page__header c-page__header"
        >
          <!-- 右侧标题 -->
          <h2
            class="c-page__header-title"
          >
            用户信息
          </h2>

          <!-- 标题栏按钮区域 Start -->
          <div
            class="c-page__header-btns"
          >
            <el-button
              type="primary"
              icon="kestrel-icon ki-search"
              @click="refreshSearch()"
            >
              查询
            </el-button>
            <el-button
              icon="kestrel-icon ki-repeat"
              @click="resetForm"
            >
              重置
            </el-button>
            <el-button
              type="success"
              icon="kestrel-icon ki-plus"
              @click="handleAddUser()"
            >
              新增
            </el-button>
            <el-button
              type="success"
              icon="kestrel-icon ki-edit"
              plain
              :disabled="!selectedRow.userCode"
              @click="handleEdit(selectedRow)"
            >
              修改
            </el-button>
            <el-button
              type="warning"
              icon="kestrel-icon ki-undo"
              plain
              :disabled="!selectedRow.userCode"
              @click="handleResetPwd(selectedRow)"
            >
              重置密码
            </el-button>
            <el-button
              type="primary"
              icon="kestrel-icon ki-unlock"
              plain
              :disabled="!selectedRow.userCode || selectedRow.locked!=='Y'"
              @click="handleUnlock(selectedRow)"
            >
              用户解锁
            </el-button>
            <el-button
              type="primary"
              icon="kestrel-icon ki-unlock"
              plain
              :disabled="!selectedRow.userCode"
              @click="handleDialog('changeDept', selectedRow)"
            >
              切换组织
            </el-button>
            <el-button
              type="primary"
              icon="kestrel-icon ki-link"
              plain
              :disabled="!selectedRow.userCode"
              @click="handleDialog('relateRole',selectedRow)"
            >
              关联岗位
            </el-button>
            <el-button
              type="primary"
              icon="kestrel-icon ki-cog"
              plain
              :disabled="!selectedRow.userCode"
              @click="handleDialog('relatePermissionDept', selectedRow)"
            >
              数据权限配置
            </el-button>
          </div>
        <!-- 标题栏按钮区域 End -->
        </div>
        <!-- 页面头部 End -->

        <!-- 查询条件 Start -->
        <div
          class="l-page__item l-page--search__item"
        >
          <hm-page-card
            title="查询条件"
            class="c-card--condition"
          >
            <!-- 查询条件表单 Start -->
            <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
            <el-form
              ref="filterParams"
              class="c-form c-condition__form"
              :model="filterParams"
              :inline="true"
              label-position="right"
              label-width="80px"
              label-suffix="："
            >
              <el-row class="c-form__row">
                <el-col
                  class="c-form__col"
                  :span="12"
                >
                  <el-form-item
                    class="c-form__item"
                    label="用户编码"
                    prop="userCode"
                  >
                    <el-input
                      v-model.trim="filterParams.userCode"
                      class="c-form__input"
                      placeholder="用户编码"
                      clearable
                      maxlength="100"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  class="c-form__col"
                  :span="12"
                >
                  <el-form-item
                    class="c-form__item"
                    label="用户名称"
                    prop="userName"
                  >
                    <el-input
                      v-model.trim="filterParams.userName"
                      class="c-form__input"
                      placeholder="用户名称"
                      clearable
                      maxlength="100"
                    />
                  </el-form-item>
                </el-col>
                <!-- <el-col
                  class="c-form__col"
                  :span="10"
                >
                  <el-form-item
                    class="c-form__item"
                    label="搜索范围"
                    prop="searchType"
                  >
                    <el-radio-group
                      v-model="filterParams.searchType"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="(value,key) in searchType"
                        :key="key"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col> -->
              </el-row>
            </el-form>
            <!-- 查询条件表单 End -->
          </hm-page-card>
        </div>
        <!-- 查询条件 End -->

        <!-- 页面主内容：查询列表 Start -->
        <div
          class="l-page__body l-page--search__body"
        >
          <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
          <el-tabs
            type="border-card"
            class="l-page__tabs l-page__tabs--single"
          >
            <el-tab-pane
              label="用户列表"
            >
              <div
                class="c-page__pTable"
              >
                <!-- table的ref的命名根据业务名称修改 -->
                <el-table
                  ref="attrUserTable"
                  class="c-page__table o-header-text-center"
                  height="100%"
                  stripe
                  border
                  highlight-current-row
                  tooltip-effect="dark"
                  :data="page.rows"
                  :class="{ 'o-table-empty-center': page.rows.length <= 0 }"
                  :row-class-name="tableRowClassName"
                  @row-click="handleRowClick"
                >
                  <el-table-column
                    class-name="c-table-column--selection"
                    width="30"
                    fixed
                  >
                    <template
                      slot-scope="scope"
                    >
                      <el-radio
                        v-model="selectedRow.userCode"
                        :label="scope.row.userCode"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="userCode"
                    label="用户编码"
                    width="120"
                    fixed
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="userName"
                    label="用户名称"
                    min-width="120"
                    fixed
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="tel"
                    label="联系电话"
                    width="120"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="email"
                    label="邮箱"
                    width="140"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="effectEndDate"
                    label="有效期"
                    width="220"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.effectStartDate | date("yyyy-MM-dd") }} 至 {{ scope.row.effectEndDate | date("yyyy-MM-dd") }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="lockedName"
                    label="锁定状态"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span
                        :class="{'u-text-success': scope.row.locked ==='N', 'u-text-danger': scope.row.locked ==='Y'}"
                      >
                        {{ scope.row.lockedName }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="validName"
                    label="有效标志"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  />
                  <el-table-column
                    prop="sourceTypeName"
                    label="数据来源"
                    width="80"
                    align="center"
                    show-overflow-tooltip
                  />
                </el-table>
                <el-pagination
                  class="c-page__pagination"
                  :disabled="page.total<=0 || loading"
                  :page-size="page.pageSize"
                  :total="page.total"
                  :current-page="page.pageNo"
                  layout="total, sizes, prev, pager, next, jumper"
                  :page-sizes="[10,15,20]"
                  @current-change="search"
                  @size-change="handleSizeChange"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 页面主内容：查询列表 End -->
      </div>
    </el-col>

    <!-- 身份岗位关联组件 -->
    <relate-role-dialog
      v-if="showDialogName==='relateRole'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleSearchCapacity"
    />

    <!-- 身份权限部门关联组件 -->
    <relate-permission-dept-dialog
      v-if="showDialogName==='relatePermissionDept'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="handleSearchCapacity"
    />

    <!-- 切换组织组件 -->
    <change-dept-dialog
      v-if="showDialogName==='changeDept'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="search"
    />
  </el-row>
</template>

<script>
import { userService } from './user.service.js';
import User from '@/features/system/attr/user/index.vue';

export default {
  name: 'SingleUserManage',
  extends: User,
  components: {
    relateRoleDialog: () => import('./capacity/relateRoleDialog'),
    relatePermissionDeptDialog: () => import('./capacity/relatePermissionDeptDialog'),
    changeDeptDialog: () => import('./changeDeptDialog')
  },
  methods: {
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;
      // 单身份查询不同接口
      userService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 移除单选按钮选中行
          this.selectedRow = {};

          this.$nextTick(() => {
            this.$refs.attrUserTable.doLayout();
          });
        })
        .catch(err => {
          console.error('查询用户出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 新增用户
     * @param {*}
     * @return {*}
     */
    handleAddUser () {
      if (!this.currentDeptCode) {
        this.$alert('请选择机构部门！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      // 单身份版新增用户
      this.openNavTab({ name: 'singleAddUser', params: { deptCode: this.currentDeptCode } });
    },

    /**
     * @description: 用户修改
     * @param {Object} 当前选中行的用户数据
     */
    handleEdit (_rowData) {
      if (_rowData.sourceType === '1') {
        this.$alert('当前用户信息数据来源为“同步”，不能修改用户信息', '提示', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        });
        return;
      }
      // 单身份版修改用户
      this.openNavTab({ name: 'singleEditUser', params: { userCode: _rowData.userCode } });
    }
  }

};
</script>
